import { render } from "./AssetsPage.vue?vue&type=template&id=58de0aa2&scoped=true"
import script from "./AssetsPage.vue?vue&type=script&lang=js"
export * from "./AssetsPage.vue?vue&type=script&lang=js"

import "./AssetsPage.vue?vue&type=style&index=0&id=58de0aa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58de0aa2"]])

export default __exports__